import { render } from "./App.vue?vue&type=template&id=94c5cfee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=94c5cfee&lang=css"

import exportComponent from "D:\\hemiao100Code\\hemiao100-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__